@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.pushpayload

import com.narbase.letsgo.router.EndPoint

object GetPushSendHistoryEndpoint :
    EndPoint<GetPushSendHistoryEndpoint.Request, GetPushSendHistoryEndpoint.Response>() {
    class Request()

    class Response(
        val sends: Array<PushSendDto>,
    )

    class PushSendDto(
        val sentOn: String,
        val sentBy: String,
        val payloadJson: String,
        val useSandbox: Boolean,
        val priority: String,
        val deliveryType: String,
        val sentCount: Int,
        val failedCount: Int,
        val results: Array<SendPushPayloadEndpoint.SendResultDto>,
    )
}
